import _Vue, { VueConstructor } from 'vue';

import * as host from './host';

import { getTranslatePlugin } from '@/Common/Environment/vue-plugins';
import { setTransport } from '@/Framework/app/rest/TransportService';

const setTranslateRuntime = (t: App.TranslateFn): VueConstructor<_Vue> => _Vue.use(getTranslatePlugin(t));
const setTransportRuntime = (transport: Host.IInitFWOptions['transport']): void =>
	setTransport(host.getBaseUrl(), false, transport);

export * as CONSTS from './events';

export {
	// Host utils
	host,
	setTranslateRuntime as setTranslate,
	setTransportRuntime as setTransport
};
